/*global TTApplicationEnum */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { v2Api, QuestionBox } from 'moovila-common';

import { showMessageBox } from '../actions';
import { redirectToApp } from '../utilities/redirect';

const globalImpersonate = (WrappedComponent) => {
  class GlobalImpersonate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        timeout: null,
        timerStarted: null,
        asking: false,
        redirect: false,
        app: '',
        userGUID: '',
        userName: '',
        impersonationSessionGUID: '',
      };
      this.checkImpersonation         = this.checkImpersonation.bind(this);
      this.setupGlobalImpersonation   = this.setupGlobalImpersonation.bind(this);
      this.impersonate                = this.impersonate.bind(this);
      this.destroyGlobalImpersonation = this.destroyGlobalImpersonation.bind(this);
    }

    checkImpersonation(APP, userGUID, userName) {
      if (this.state.userGUID && this.state.userGUID !== userGUID) {
        this.destroyGlobalImpersonation();
      }
      v2Api
      .fetch('Security/ImpersonateUser', {userGUID})
      .then(({data}) => {
        if (data.hasActiveImpersonation) {
          // pop question box asking if they'd like to proceed
          this.setState({
            timeout: null,
            timerStarted: null,
            asking: true,
            app: APP,
            userGUID,
            userName,
            impersonationSessionGUID: data.impersonationSessionGUID,
          });
        } else {
          if (moment(this.state.timerStarted).add(5, 'm').isBefore(moment())) {
            // kill it and notify it was never approved
            this.props.showMessageBox({
              title: 'Request Expired',
              message: `Your RemoteAssist request to ${userName} has expired`
            })
            this.destroyGlobalImpersonation();
            return;
          }
          // setup the timeout!
          this.setState({
            timeout: setTimeout(() => this.checkImpersonation(APP, userGUID, userName), 10000),
            timerStarted: this.state.timerStarted || moment(),
          });
        }
      });
    }

    impersonate() {
      if (this.state.app !== TTApplicationEnum.MOM) {
        redirectToApp(this.state.app, this.state.impersonationSessionGUID, true);
      } else {
        redirectToApp(this.state.app, this.state.impersonationSessionGUID, false);
      }
      this.destroyGlobalImpersonation();
    }

    setupGlobalImpersonation(APP, userGUID, userName) {
      this.checkImpersonation(APP, userGUID, userName);
    }

    destroyGlobalImpersonation() {
      this.setState({
        timeout: null,
        timerStarted: null,
        app: '',
        userGUID: '',
        userName: '',
        impersonationSessionGUID: '',
        asking: false,
      });
    }

    render() {
      let modal = null;
      if (this.state.asking) {
        modal = <QuestionBox
                  title='RemoteAssist Request'
                  yesCallback={this.impersonate}
                  noCallback={this.destroyGlobalImpersonation}
                >{this.state.userName} has approved your RemoteAssist request. Would you like to connect now?</QuestionBox>
      }
      return (
        <div>
          <WrappedComponent
            {...this.props}
            setupGlobalImpersonation={this.setupGlobalImpersonation}
          />
          { modal }
        </div>
      );
    }
  }

  return connect(s => s, {
    showMessageBox,
  })(GlobalImpersonate);
};

export default globalImpersonate;



// WEBPACK FOOTER //
// ./src/components/globalImpersonate.js